import { createSelector, Selector } from '@ngrx/store';
import { selectShared } from './shared.selectors';
import { FilterAttendee } from '../models';
import { Pack } from '@cue/data';

export const loadedAttendees: Selector<any, Pack<FilterAttendee[]>> = createSelector(
  selectShared,
  (state) => state.filterAttendees
);
